import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import HTTPRequest from "./HTTPRequest";
import wpCache from "../global/wpCache";

const SKIP_CACHE_PAGES = [
  "ContactUs",
  "Disclaimer",
  "PrivacyPolicy",
  "TermsAndConditions",
  "Sitemap",
  "404",
  "UnderConstruction",
  "Search",
];

export default function CacheInitializer({ onReady }) {
  const location = useLocation();
  const hasInitialized = useRef(false);
  const readyNotified = useRef(false);

  const notifyReady = () => {
    if (readyNotified.current) {
      return;
    }
    readyNotified.current = true;
    if (typeof onReady === "function") {
      onReady();
    }
  };

  const enabled =
    String(
      process.env.REACT_APP_ENABLE_WP_CACHE_INITIALIZER || "true",
    ).toLowerCase() === "true";

  const cacheTtlMinutes = Number(
    process.env.REACT_APP_WP_STATIC_JSON_CACHE_TTL_MINUTES || 60,
  );
  const ttlMs =
    Number.isFinite(cacheTtlMinutes) && cacheTtlMinutes > 0
      ? cacheTtlMinutes * 60 * 1000
      : 60 * 60 * 1000;
  const cacheVersion = Math.floor(Date.now() / ttlMs);

  useEffect(() => {
    if (!enabled) {
      notifyReady();
      return;
    }

    const pathParts = location.pathname.split("/").filter(Boolean);
    const currentPage = pathParts[0] || "Index";

    if (Object.keys(wpCache).length > 0) {
      notifyReady();
      return;
    }

    if (SKIP_CACHE_PAGES.includes(currentPage) || hasInitialized.current) {
      return;
    }

    hasInitialized.current = true;

    // const baseUrl = process.env.REACT_APP_cmsRootUrl + process.env.REACT_APP_cmsPageurl;
    const baseUrl = process.env.REACT_APP_AtlasWSurl;
    // const urls = [
    //   `${baseUrl}?per_page=100&_fields=id,content&offset=0`,
    //   `${baseUrl}?per_page=100&_fields=id,content&offset=100`,
    // ];
    const urls = [
      `${baseUrl}AtlasContent0100?v=${cacheVersion}`,
      `${baseUrl}AtlasContent101200?v=${cacheVersion}`,
    ];

    const fetchAndCache = (url) => {
      return new Promise((resolve) => {
        HTTPRequest.getJson(url, false, (result) => {
          if (Array.isArray(result)) {
            result.forEach((page) => {
              if (page.id && page.content) {
                wpCache[page.id] = page;
              }
            });
          }
          resolve();
        });
      });
    };

    Promise.all(urls.map(fetchAndCache))
      .then(() => {
        console.log(
          "[CacheInitializer] Global wpCache populated with",
          Object.keys(wpCache).length,
          "pages",
        );
        notifyReady();
      })
      .catch((err) => {
        console.error("[CacheInitializer] Failed to populate wpCache", err);
        // Allow app navigation even if preload fails; useTheme fallback keeps app usable.
        notifyReady();
      });
  }, [enabled, location.pathname]);

  return null;
}
